import { render } from "./DateRangeDisplay.vue?vue&type=template&id=ad5ae470"
import script from "./DateRangeDisplay.vue?vue&type=script&lang=js"
export * from "./DateRangeDisplay.vue?vue&type=script&lang=js"

import "./DateRangeDisplay.vue?vue&type=style&index=0&id=ad5ae470&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__